import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Error404 from "../../Error404";
import RegisterLinkPage from "./register-link";

export default ({ match }) => {
  return (
    <Switch>
      <Route exact path={`${match.path}`}>
        <Redirect to={`${match.path}/register-link`} />
      </Route>
      <Route
        path={`${match.path}/register-link`}
        component={RegisterLinkPage}
      />
      <Route component={Error404} />
    </Switch>
  );
};
